// @ts-check

import React, { Component } from "react"
import { BlockContextConsumer } from "../ContextProviders"
import { validateBroadcast } from "./utils"

/**
 * @augments {Component<{context: BlockContext, broadcast: Broadcastable}>}
 */
class DefineBroadcast extends Component {
    componentDidMount() {
        const blockId = this.props.context.block.id
        const { broadcast } = this.props

        if (!broadcast.published_name) {
            broadcast.published_name =
                this.props.context.block.config.attributes[
                    "broadcast." + broadcast.channel + "." + broadcast.name
                ] || broadcast.name
        }
        validateBroadcast(broadcast)

        this.broadcastId = broadcast.id

        this.props.context.broadcast.add(blockId, broadcast)
        this.props.context.actions.addBroadcast(blockId, broadcast)
    }
    componentWillUnmount() {
        const blockId = this.props.context.block.id

        this.props.context.broadcast.remove(blockId, this.broadcastId)
        this.props.context.actions.removeBroadcast(blockId, this.broadcastId)
    }
    render() {
        return null
    }
}

DefineBroadcast.propTypes = {}

export default function DefineBroadcastInContext(props) {
    return (
        <BlockContextConsumer>
            {context => <DefineBroadcast {...props} context={context} />}
        </BlockContextConsumer>
    )
}



// WEBPACK FOOTER //
// ./src/features/editor/broadcast/DefineBroadcast.js